<template>
	<div :class="this.collapse ? 'top-col' : 'top'" style="">
		<div style="margin: 36px 0;max-width: 26%;">
			<img src="../assets/head/logo.png" alt="" class="top-title">
		</div>
		<div @mouseleave="mouseleaveSearch" :class="bg?'bg-1':'bg-4'">
			<div class="col-style" style="width: 100%;">
				<div class="col-style-2">
					<el-select v-model="value" placeholder="专家" class="place" @change="handelChange"
						style="border-right: 1px solid #EFEFEF;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-input id="myInput" v-model="input" placeholder="请输入搜索内容" class="elinput" @focus="hancleClick"
						@blur="sechBlur($event)" v-if="isLockSearch==false">
					</el-input>
					<el-button type="primary" @click="selectSeach" v-if="isLockSearch==false">搜索</el-button>
					<el-input v-model="input" placeholder="请输入搜索内容" class="" @focus="expertSearchClick" v-if="isLockSearch">
					</el-input>
					<el-button type="primary" @click="expertSearchClick" v-if="isLockSearch">搜索</el-button>
				</div>
			</div>
			<div :class="bg?'bg-2':'bg-3'">
				<div style="">
					<div class="is-flex sousuo">
						<div class="sousuo-1">最近搜索</div>
						<div class="is-flex cursor" @click="deleteAll">
							<img src="../assets/home/delet.png" alt="" class="sou-img">
							<p style="padding-left: 3px;">清空</p>
						</div>
					</div>
					<!-- 收起展开 -->
					<div class="is-flex name-list">
						<div class="is-flex list-1" v-for="(item,index) in showHandleList" :key="item.index"
							style="justify-content: unset;">
							<p style="" @click="huoqu(item.content)">{{item.content}}</p>
						</div>
						<div class="is-flex list-2 cursor" v-if="this.list.length > 8" @click="showAll = !showAll">
							<p class="words">{{word}}</p>
							<i class="el-icon-arrow-down" v-if="!showAll"></i>
							<i class="el-icon-arrow-up" v-if="showAll"></i>
						</div>

					</div>
				</div>
				<div class="remen">
					<div class="re-1">热门搜索</div>
					<div class="remenlist">
						<p class="re-mr" v-for="(item1,index1) in listHot.slice(0,8)" :key="index1"
							@click="huoqu(item1.name)">{{item1.name}}</p>
					</div>
				</div>

			</div>

		</div>
		<div style="margin-right: 3rem;">
			<div class="is-flex" style="align-items: center;max-width: 300px;">
				<img src="../assets/head/lian.png" alt="">
				<p
					style="font-family: font10;color: #3377FF;font-size: calc(100vw * 16 / 1400);padding-left: 0.5rem;white-space: nowrap;">
					{{this.mobile}}
				</p>
			</div>
		</div>
		<!-- beijing 登录切换 -->
		<div :class="this.collapse ? 'login-1' : 'login-top'">
			<p class="loginin cursor" v-if="!this.cologOut" style="" @click="goLogin">登录/注册</p>
			<div style="position: relative;" v-if="this.cologOut">
				<img :src="user.avatar" alt="" class="actor-1" @click="actor">
				<div class="popul" @mouseleave="shouws = false" v-show="shouws">
					<p class="actives myself" @click="myself">个人中心</p>
					<div class="actives my-1" @click="loginout">
						<div class="out">
							<div>
								<img src="../assets/head/out-1.png" alt="">
								<span class="out-span">退出</span>
							</div>
							<div>
								<img src="../assets/head/out.png" alt="">
								<span class="out-span">退出</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 退出提示 -->
			<el-dialog title="" :visible.sync="dialogOut" width="25%">
				<div class="flex-1 jus-bet">
					<div></div>
					<div>
						<div class="flex-1 jus-bet">
							<div></div>
							<div class="flex-1 tan-1">
								<img src="../assets/myself/tixing.png" alt="">
								<p>确定退出登录吗?</p>
							</div>
							<div></div>
						</div>
						<div class="tishis flex-1">
							<p @click="handleClose">取消</p>
							<p @click="handleLogout">确定</p>
						</div>
					</div>
					<div></div>
				</div>

			</el-dialog>

		</div>
		<!-- <div>

        </div> -->
	</div>
</template>

<script>
	import {
		getInfo,
		getUser,
		getLogout,
		getSearchRecordPage,
		getHotSearch,
		getDeleteSearch
	} from '@/api/api.js';
	export default {
		props: {
			isLockSearch: Boolean
		},
		data() {
			return {
				input: '',
				value: '1',
				options: [{
					value: '1',
					label: '专家'
				}, {
					value: '2',
					label: '学校'
				}, {
					value: '3',
					label: '活动'
				}],
				collapse: false,
				list: [],

				showAll: false,
				visible: false,
				shouws: false,
				dialogOut: false,
				mobile: '',
				user: '',
				cologOut: false,
				listHot: [],
				seachType: '1',
				bg: false
			}
		},
		created() {

		},
		mounted() {
			this.getInfos();
			this.getUsersa();
			this.getList();
		},
		computed: {
			showHandleList() {
				if (this.showAll == false) { //收起状态-显示“展示”        
					var showList = []; //定义⼀个空数组        
					if (this.list.length > 9) { //控制显⽰前四个          
						for (var i = 0; i < 9; i++) {
							showList.push(this.list[i]) //将数组的前4条存放到showList数组中        
						}
					} else {
						showList = this.list; //个数足够显示，不需要再截取        
					}
					return showList; //返回当前数组      
				} else { // 展开状态-显示“收起”      
					return this.list;
				}
			},
			word() {
				if (this.showAll == false) { //对⽂字进⾏处理        
					return '更多'
				} else {
					return '收起'
				}
			}
		},
		methods: {
			mouseleaveSearch() {
				// this.bg = false;
				// let inputElement = document.getElementById("myInput");
				// inputElement.blur();
			},
			goLogin() {
				this.$root.loginShow = true;
				this.$emit('getLoginShow', true);
			},
			getList() {
				let params = {
					pageNo: 1,
					pageSize: 100
				}
				getSearchRecordPage(params).then(res => {
						this.list = res.data.list;
					})
					.catch(error => {});
				getHotSearch(params).then(res => {
						this.listHot = res.data.list;
					})
					.catch(error => {});

			},
			handelChange(val) {
				console.log(val, 'va----')
				this.seachType = val;
				// if (val == 1) {

				// }
			},
			searchType() {
				this.getList();
				if (this.seachType == 1) {
					this.$router.push({
						name: 'wisdom',
						params: {}
					})
				} else if (this.seachType == 2) {
					this.$router.push({
						name: 'school',
						params: {}
					})
				} else if (this.seachType == 3) {
					this.$router.push({
						name: 'activity',
						params: {}
					})
				}
			},
			selectSeach() {
				this.$root.searchText = this.input;
				if (this.seachType == 1) {
					this.$router.push({
						name: 'wisdom',
						params: {
							selectType: 1,
							selectName: this.input,
							seachType: this.seachType,
							footersType: 1,
						}
					})
					this.bg = false;
					// this.input = ''
				} else if (this.seachType == 2) {
					this.$router.push({
						name: 'school',
						params: {
							selectType: 2,
							title: this.input,
							footersType: 1,
						}
					})
					this.bg = false;
					// this.input = ''
				} else if (this.seachType == 3) {
					this.$router.push({
						name: 'activity',
						params: {
							selectType: 3,
							title: this.input,
							footersType: 1,
						}
					})
					this.bg = false;
					// this.input = ''
				}
			},
			// 清空搜索记录
			deleteAll() {
				let arr = []
				this.list.forEach((item, index) => {
					arr.push(item.id)
				})
				let params = {
					ids: arr.join(',')
				}
				getDeleteSearch(params).then(res => {
						if (res.code == 0) {
							this.$message.success('清空成功！')
							this.getList();
						}
					})
					.catch(error => {});

			},

			getUsersa() {
				getUser().then(res => {
						this.user = res.data;
						if (this.user == null) {
							this.cologOut = false;
						} else {
							this.cologOut = true;
							this.$store.commit('gertUsers', this.user)
						}
					})
					.catch(error => {});
			},
			getInfos() {
				getInfo().then(res => {
						this.mobile = res.data.mobile;

					})
					.catch(error => {});
			},
			hancleClick(val) {
				this.bg = !this.bg;
				this.getList();

				// if (val !== '') {
				//     this.collapse = !this.collapse;
				// }
				// this.collapse = true;
			},
			sechBlur(event) {
				// if(event.type=='blur'){
				//     this.bg = false
				// }

			},
			clickClose() {
				this.collapse = false;
			},
			actor() {
				this.shouws = !this.shouws
			},
			loginout() {
				this.dialogOut = true;
			},
			handleClose() {
				this.dialogOut = false
			},
			handleLogout() {
				getLogout().then(res => {
						if (res.code == 0) {
							localStorage.setItem('advertisementShow', '');
							localStorage.setItem('keyToken', '');
							this.dialogOut = false;
							this.user = '';
							this.cologOut = false;
							this.$router.go(0);
						}
					})
					.catch(error => {});
			},
			myself() {
				this.$router.push('/personal/index')
			},
			huoqu(content) {
				this.input = content;
				console.log(this.input)
				this.selectSeach();
			},
			expertSearchClick() {
				this.$router.push({
					name: 'wisdom',
					params: {}
				})
			},
			getSearchType() {
				return this.value;
			}

		}
	}
</script>

<style scoped>
	.top {
		display: flex;
		align-items: center;
		padding: 0 19%;
		justify-content: space-between;
		/* margin: 36px 0; */
		position: relative;
		max-width: 1200px;
		margin: 0 auto;
	}

	.top-col {
		display: flex;
		align-items: center;
		padding: 0 19%;
		justify-content: space-between;
		max-width: 1200px;
		margin: 1.9% auto;
	}


	.top-title {
		/* width: 277px;
        height: 64px; */
		max-width: 100%;
		/* max-width: 100%; */
		height: auto;
	}

	.tel {
		width: 176px;
		height: 30px;
		/* padding-right: 32px; */
	}

	.el-select .el-input {
		width: 130px;
	}

	.input-with-select .el-input-group__prepend {
		background-color: #fff;
	}

	/deep/.el-input .el-input--suffix {
		width: 80px;
		border-right: 1px solid;

		.el-input__inner {
			font-size: 14px;
			color: #222222 !important;
			;
		}
	}

	/deep/.el-input-group {}

	/deep/.el-input .el-input__inner {
		border-radius: 0;
		border: 0;
		background-color: rgba(0, 0, 0, 0);
		width: 80px;
		font-size: 14px;

	}

	/deep/.el-button--primary {
		color: #FFFFFF;
		background-color: #3377FF;
		border: none;
		font-size: 14px;
		font-weight: normal;
		border-radius: 0 6px 6px 0;
		width: 92px;
		padding: 0.75rem;
	}

	/deep/.el-button--primary:active {
		background-color: rgba(51, 119, 255, 0.7);
	}

	/* /deep/.el-button--primary:hover{background-color:rgba(51, 119, 255, 1);} */
	/deep/.elinput .el-input__inner {
		width: 100%;
		font-size: 14px;
	}

	/deep/.elinput .el-input__inner::placeholder {
		color: #cccccc;
	}

	/deep/.el-select .el-input .el-select__caret {
		color: #222222;
	}

	/deep/.place .el-input__inner::placeholder {
		color: #222222;
		/*将Placeholder文字颜色修改为红色*/
	}

	/deep/.place {
		/* width: 80px; */
	}

	.col-style {
		width: 40%;
		display: flex;

		/* margin-left: 78px; */
		/* margin-right: 59px; */
	}

	.col-style-2 {
		display: flex;
		border: 1px solid #3377FF;
		border-radius: 8px;
	}

	.search-1 {
		background: #FFFFFF;
		border-radius: 0px 0px 8px 8px;
		width: 100%;
	}

	.search-2 {
		display: flex;
		border: 1px solid #3377FF;
		border-radius: 8px;
		margin: 45px 24px 24px 24px;
	}

	.search-3 {
		display: flex;
		width: 100%
	}

	.is-flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.login-top {
		display: flex;
		align-items: center;
		/*   position: absolute;
            right: 25%; */
	}

	.login-1 {
		position: relative;
		/* right: 475px; */
		display: flex;
		align-items: center;
	}

	.actives {
		color: #222222;
		background: #fff;
	}

	.actives:hover {
		color: #3377FF;
		background: #F0F5FF;
	}

	.actives p {
		color: #222222;
	}

	.actives p:hover {
		color: #3377FF;
	}

	/*  .out{
          background-image: url("../assets/head/out-1.png");
          background-repeat: no-repeat;
          background-size: 100%;
      }
      .out:hover{
          background-color: red;
       
      } */
	.out div {
		vertical-align: middle;
		/* display: flex;justify-content: space-between;align-items:center; */
	}

	.out {
		border-radius: 8px;
	}

	.out>div>img {
		/* width: 18px;
        height: 18px;
        margin-left: 19px; */
		vertical-align: middle;
	}

	.out>div:last-child {
		display: none;
	}

	.out:hover>div:last-child {
		display: block;
	}

	.out:hover>div:first-child {
		display: none;
	}

	.loginin {
		/* width: 83px;
        height: 40px; */
		background: #3377FF;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		padding: 0 10px;
		white-space: nowrap;
		/* margin-right: -5px; */
	}

	.sousuo {
		padding: 0 24px 0 24px;
		font-size: 12px;
		color: #666666;
	}

	.sousuo-1 {
		margin-bottom: 4px;
	}

	.sou-img {
		width: 12px;
		height: 12px;
	}

	.name-list {
		justify-content: unset;
		flex-wrap: wrap;
		padding: 8px 24px 0 24px;
		position: relative;
	}

	.list-1 {
		font-size: 12px;
		color: #222222;
		padding-right: 1rem;
		margin-bottom: 0.5rem;
	}

	.list-2 {
		margin-bottom: 8px;
		position: absolute;
		right: 1rem;
		bottom: 0;
	}

	.words {
		font-size: 12px;
		color: #222222;
		margin-right: 4px;
	}

	.remen {
		padding: 24px 24px 45px 24px;
	}

	.re-1 {
		font-size: 12px;
		color: #666666;
		margin-bottom: 8px;
	}

	.remenlist {
		font-size: 12px;
		color: #222222;
		display: flex;
		align-items: center;
		display: flex;
		flex-wrap: wrap;
	}

	.re-mr {
		margin-right: 16px;
		white-space: nowrap;
	}

	.popul {
		background-color: #FFFFFF;
		position: absolute;
		z-index: 999;
		text-align: center;
		font-size: 14px;
		box-shadow: 2px 6px 8px 2px rgba(51, 119, 255, 0.24);
		cursor: pointer;
		border-radius: 8px;
		right: -24%;
	}

	.actor-1 {
		width: 4rem;
		height: 4rem;
		border-radius: 50%;

	}

	.myself {
		line-height: 40px;
		padding: 0px 16px;
		white-space: nowrap;
	}

	.my-1 {
		padding: 10px 16px;
		align-items: center;
	}

	.out-span {
		padding-left: 1px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.tan-1 {
		margin-bottom: 32px;
	}

	.tan-1 img {
		width: 22px;
		height: 22px;
	}

	.tan-1 p {
		color: #2D2D2E;
		font-weight: font5;
		font-size: 18px;
		padding-left: 10px;
	}

	/deep/.el-icon-close:before {
		display: none;
	}

	/deep/.el-dialog {
		border-radius: 8px;
	}

	/deep/.el-dialog__header {
		padding: 0;
	}

	/deep/.el-dialog__body {
		padding: 20px;
	}

	.tishis p {
		font-size: 16px;
		padding: 12px 44px;
		border-radius: 4px 4px 4px 4px;
	}

	.tishis p:first-child {
		color: #666666;
		background-color: #EFEFEF;
		margin-right: 2.5rem;
	}

	.tishis p:last-child {
		color: #FFFFFF;
		background-color: #3377FF;
	}

	.bg-1 {
		padding: 45px 24px;
		box-shadow: 0px 6px 8px 0px rgba(51, 119, 255, 0.24);
		position: relative;
		/* margin: 0 100px; */
	}

	.bg-2 {
		width: 100%;
		position: absolute;
		z-index: 999;
		box-shadow: 0px 6px 8px 0px rgba(51, 119, 255, 0.24);
		padding: 24px 0 0 0;
		background: #FFFFFF;
		left: 0;
		border-radius: 5px;
	}

	.bg-3 {
		display: none;
	}

	.bg-4 {
		padding: 45px 24px;
		/* margin: 0 100px; */
	}
</style>